<template>
    <div class="main">
      <Header></Header>
      <loader v-if="loader"></loader>
      <b-container v-else class="main-container p-0">
        <ConfirmMail :modal1_mail_confirm="modal1_mail_confirm"></ConfirmMail>
        <ConfirmPhone :modal1_phone_confirm="modal1_phone_confirm"></ConfirmPhone>
        <b-row class="if-no-active-bills" no-gutters v-if="!account_numbers.length">
          <b-col class="if-no-active-bills-col m-4">
            <span>
              {{'LSNoList' | localize}}
              <router-link 
                class="add-new-address-link" 
                tag="strong" 
                :to ="{ name: 'NewAddress' }"
              >
                {{'LSAddNewLs' | localize}}
              </router-link> 
            </span> 
          </b-col>
        </b-row>
        <b-row 
          v-else-if="account_numbers" 
          class="user-bill" 
          no-gutters
        >
          <b-col 
            class="user-bill-info" 
            cols="12"
          >
            <div class="bill-info-head">
              {{'LSList' | localize}}:
            </div>
            <div 
              v-for="user of account_numbers" :key="user.id" 
              class="bill-numder px-3"
            >
              <div class="bill-numder-info">
                <div class="mx-4">
                  <div class="account"><b>{{user.account_id}}</b> <b-link :to="{ path:`${route_prefix}/account/${user.account_id}`}">{{'Detailed' | localize}}</b-link></div>
                  <div class="address">{{ account_data[user.account_id].street_name }}, {{ account_data[user.account_id].dom }}, кв {{ account_data[user.account_id].flat_num }}</div>
                  <div class="name">{{ account_data[user.account_id].surname }} {{ account_data[user.account_id].f_name }} {{ account_data[user.account_id].m_name }}</div>
                </div>
              </div>
              <div class="mx-4 bill-money-info">
                <div :class="account_data[user.account_id].bill_status">
                  <div v-if="account_data[user.account_id].bill_status === 'plus'" class="status">{{'Overpay' | localize}}</div>
                  <div v-if="account_data[user.account_id].bill_status === 'minus'" class="status">{{'Underpay' | localize}}</div>
                  <div v-if="account_data[user.account_id].bill_status === 'zero'" class="status">{{'Underpay' | localize}}</div>
                  <div class="balance">{{ account_data[user.account_id].balance_today }} грн</div>
                </div>
                <b-button
                    v-if="account_data[user.account_id].bill_status === 'minus'"
                    size="sm"
                    variant="outline-success"
                    class="  style-button button-pay mx-auto"
                    :href="zsslink(user.account_id)"
                    target="_blank"
                >
                  {{'mainPayButton' | localize}}
                  <div class="style-button-icon">
                    <b-icon icon="credit-card" ></b-icon>
                  </div>
                </b-button>
              </div>

            </div>

          </b-col>
        </b-row>
        <b-row v-if="public_info.notification" class="notifications-block px-2"><a :href="language(public_info.notification.link)" v-if="language(public_info.notification.link) !== ''"><span v-html="public_info.notification.text[$store.state.lang]"></span></a> <span v-if="language(public_info.notification.link) === ''" v-html="public_info.notification.text[$store.state.lang]"></span></b-row>
        <b-row class="info-block" no-gutters>
          <b-col class="user-bill-info" cols="12" >
            <div class="bill-info-head">
            {{'mainInfoBlock' | localize}}:
            </div>
            <div class="address-info" v-if="public_info.addresses">
                <div class="address-title">
                  <b-icon icon="building" aria-hidden="true" variant="danger"></b-icon>
                  {{'mainInfoBlockAddress' | localize}}:</div>
                <div class="address-list">
                  <div v-for="(addr, i) in public_info.addresses" :key="i"><span v-html="addr.title[$store.state.lang]"></span> &nbsp;<span v-if="addr.address">— <span v-html="addr.address[$store.state.lang]"></span></span> </div>
                </div>
            </div>
            <div class="address-info" v-if="public_info.contacts">
                <div class="address-title">
                  <b-icon icon="telephone" aria-hidden="true" variant="danger"></b-icon>
                  {{'mainInfoBlockPhones' | localize}}:
                </div>
                <div class="address-list">
                  <div v-for="(contact, i) in public_info.contacts" :key="i">
                    {{ contact.title | lang }} —
                    <span v-if="contact.phones">
                      <span v-for="(phone, i) in contact.phones" :key="i"><a class="telephone" :href="`tel:${phone}`">{{ phone | phone }}</a><span v-if="(i < (contact.phones.length - 1)) || contact.emails">,</span></span>
                    </span>
                    <span v-if="contact.emails">
                      <span v-for="(email, i) in contact.emails" :key="i"><a class="telephone" :href="`mailto:${email}`">{{ email }}</a><span v-if="i < contact.emails.length - 1">,</span></span>
                    </span>
                  </div>
                </div>
            </div>
            <div class="address-info-noborder" v-if="public_info.schedule">
                <div class="address-title"> 
                  <b-icon icon="clock" aria-hidden="true" variant="danger"></b-icon>
                  {{'mainInfoBlockWork' | localize}}: 
                </div>
                <div class="address-list">
                  <div class="schedule" v-for="(task, i) in public_info.schedule" :key="i">{{ task.title | lang }} — &nbsp;<span v-html="task.text[$store.state.lang]"></span></div>
                </div>
            </div>
          </b-col>
        </b-row>          
      </b-container>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '../components/Header'
import loader from '../components/Loader'
import ConfirmMail from '../components/userProfile/forms/ConfirmMail'
import ConfirmPhone from '../components/userProfile/forms/ConfirmPhone'
import config from '@/config'
import {sha256} from "js-sha256";
import base64url from "base64url";
import axios from "axios";
import langFilter from "../filters/langFilter";

const ROUTE_PREFIX = config.ROUTE_PREFIX
const API_URL = config.API_URL
export default {
  data: ()=>({
    modal1: false,
    loader: false,
    user_more_info: false,
    account_numbers: [],
    account_data: {},
    verificationMail: null,
    verificationTel: null,
    route_prefix: ROUTE_PREFIX,
    public_info:{},
    modal1_mail_confirm: false,
    modal1_phone_confirm: false
  }),
  methods: {
    language: function (key) {
      return langFilter(key)
    },
    // zsslink: function (account){

     
    //     let url = 'https://next.privat24.ua/payments/form/{"token":"8645c2735a4bc4a50540b183b9969ed6z4xh3v8x","personalAccount":"'+ account +'"}';

    //   return url;
    // }
    zsslink: function (account){

     
      let url = 'https://ips.ua/faces/api/proc?t=ue6TwAuZjJhAksHHuL0x_0cDxnrlhUufR2OHtiQGzkw.&p=3&b='+ account;

      return url;
    }
  },
  mounted: async function () {
    this.loader = true
    localStorage.setItem('weltumLastUrl', window.location.pathname)
    await this.$store.dispatch('userAccountsFetch')

    await this.$store.dispatch('verification', 1)
    this.verificationMail = this.userVerificationMailAnsver
    if (this.verificationMail === 'Почтовый адрес не подтвержден !') {
      this.modal1_mail_confirm = true
    }
    await this.$store.dispatch('verification', 2)
    this.verificationTel = this.userVerificationTelAnsver
    if (this.verificationTel === 'Телефон не подтвержден !') {
      this.modal1_phone_confirm = true
    }

    this.account_numbers = this.userAccountsNumbers
    if (this.account_numbers.length && this.account_numbers[0].err === "Сессия просрочена !") {
      await this.$store.dispatch('logout')
      this.$router.push({path: `${ROUTE_PREFIX}/login`})
      this.$toastLocalized("sessionTerminated")
    }

    const key = localStorage.getItem("weltumKey")
    const Time = Date.now().toString()
    const test = sha256.hmac(key, Time);
    const Hmac = base64url(test)
    let promises = []
    let items = {}
    let info = {}
    this.account_numbers.map(async function(item) {
      promises.push(
          axios.get(
              `${API_URL}/api/rest/receipt/account_addres_info?lico=${item.account_id}&secret_key=${key}`,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'X-Hmac': Hmac,
                  'X-Time': Time,
                }
              },
          ).then((response) => {
            item = response.data.items[0]
            if(item.balance_today < 0.0){
              item.bill_status = 'plus'
            }else if(item.balance_today > 0.0){
              item.bill_status = 'minus'
            }else{
              item.bill_status = 'zero'
            }
            items[item.account_id.toString()] = item
          })
      )
    });
    promises.push(
        axios.get(
            `${API_URL}/api/rest/receipt/info_predpr?tema=0&secret_key=${key}`,
            {
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Hmac': Hmac,
                'X-Time': Time,
              }
            },
        ).then((response) => {
          info = response.data
        })
    )
    Promise.all(promises).then(() => {
      this.account_data = items
      this.public_info = info
      this.loader = false

    });
  },
  computed: mapGetters(['userAccountsNumbers',  'locale', 'userVerificationMailAnsver', 'userVerificationTelAnsver']),
    components: {
      Header,
      loader,
      ConfirmMail,
      ConfirmPhone
    }
}
</script>
